// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { awBorderGrey } from 'Utils/themes';

// One speech bubble, not a card floating on the mapbox popup's own white box:
// the popup chrome is stripped so the card IS the bubble, and the popup tip
// becomes its tail (Mikaela's reference shape, 09-03). No theme tokens needed,
// so it lives outside the theme'd styles function.
export const popupShell = {
  '& .mapboxgl-popup-content': {
    background: 'transparent',
    padding: 0,
    boxShadow: 'none',
    borderRadius: 0,
  },
  '& .mapboxgl-popup-tip': {
    borderWidth: '12px',
    borderTopColor: '#ffffff',
    marginTop: '-1px',
  },
};

const styles = (theme: any) => ({
  switchCard: {
    position: 'absolute',
    top: theme.spacing(2),
    right: theme.spacing(2),
    zIndex: 10,
    bgcolor: 'white',
    borderRadius: 1,
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
  },
  switchRow: {
    display: 'flex',
    alignItems: 'center',
    pl: 1.5,
    pr: 0.5,
  },
  switchControl: {
    m: 0,
  },
  switchLabel: {
    fontSize: '12px',
    fontWeight: 400,
  },
  chevronButton: {
    p: 0.25,
    ml: 0.25,
    color: 'text.secondary',
    // The sx color would otherwise beat the default Mui-disabled grey; the
    // off-state chevron must read disabled (D87).
    '&.Mui-disabled': {
      color: 'action.disabled',
    },
  },
  kindRows: {
    borderTop: `1px solid ${theme.palette.divider}`,
    mx: 1,
    py: 0.5,
  },
  kindRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: 1.5,
    pl: 0.5,
    pr: 0.75,
  },
  kindControl: {
    m: 0,
    flexGrow: 1,
  },
  kindCheckbox: {
    py: 0.5,
    pl: 0,
    pr: 0.75,
  },
  cornerLabel: {
    bgcolor: 'white',
    borderRadius: 1,
    px: 1,
    py: 0.25,
    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
    pointerEvents: 'none',
    whiteSpace: 'nowrap',
    m: 0.5,
    opacity: 0.9,
  },
  cornerLabelHovered: {
    opacity: 1,
    boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
  },
  cornerLabelText: {
    fontSize: '11px',
    lineHeight: 1.3,
  },
  // Card chrome mirrors the dashboard map's ProjectOverviewCard (AUT-6113).
  card: {
    width: 'min(280px, calc(100vw - 32px))',
    borderRadius: '12px',
    border: `1px solid ${awBorderGrey}`,
    backgroundColor: 'background.paper',
    boxShadow: '2px 6px 4px rgba(0, 0, 0, 0.1)',
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '8px',
  },
  cardName: {
    fontSize: '14px',
    fontWeight: 500,
    letterSpacing: '0.5px',
    lineHeight: 1.35,
    color: 'text.primary',
    minWidth: 0,
    // Filenames are unbroken strings; without this a long name overflows
    // instead of wrapping.
    overflowWrap: 'anywhere',
  },
  closeButton: {
    width: 24,
    height: 24,
    padding: 0,
    fontSize: '13px',
    lineHeight: 1,
    marginTop: '-4px',
    marginRight: '-6px',
  },
  downloadButton: {
    padding: '4px',
  },
  selectButton: {
    fontSize: '12px',
    marginTop: '4px',
  },
  pagerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: '4px',
  },
  pagerButton: {
    fontSize: '12px',
    minWidth: 0,
  },
  pagerLabel: {
    fontSize: '12px',
    color: 'text.secondary',
  },
});

export default styles;
